<ip-reputation-db-list-page
    [ipReputationDB]="activeIPReputationDB"
    [status]="status"
    (onEditPulseSettings)="redirectToCloudServices()"
></ip-reputation-db-list-page>
